const thumbHeight = {
  thumbs: document.querySelectorAll(
    '.product-box__title',
  ) as NodeListOf<HTMLElement>,

  observer: null as MutationObserver | null,

  init() {
    this.refreshTitles();
    this.checkExpandableTitles();
    this.observeProducts();

    window.addEventListener('resize', () => {
      this.refreshTitles();
      this.checkExpandableTitles();
    });
  },

  refreshTitles() {
    this.thumbs = document.querySelectorAll(
      '.product-box__title',
    ) as NodeListOf<HTMLElement>;
  },

  checkExpandableTitles() {
    if (window.innerWidth < 1200) {
      this.thumbs.forEach((item) => {
        item.classList.remove('is-expandable');
      });

      return;
    }

    this.thumbs.forEach((item) => {
      const card = item.closest('.product-box') as HTMLElement | null;

      if (!card) return;

      /*
       * Skip cards that are currently hidden.
       * They will be checked once they become visible.
       */
      if (card.offsetParent === null) {
        item.classList.remove('is-expandable');

        return;
      }

      item.classList.remove('is-expandable');

      const clampedHeight = item.clientHeight;

      const webkitLineClamp = item.style.webkitLineClamp;
      const overflow = item.style.overflow;
      const display = item.style.display;
      const height = item.style.height;

      /*
       * Temporarily remove the clamp/fixed height
       * so we can measure the full title.
       */
      item.style.webkitLineClamp = 'unset';
      item.style.overflow = 'visible';
      item.style.display = 'block';
      item.style.height = 'auto';

      const fullHeight = item.scrollHeight;

      /*
       * Restore original inline styles.
       */
      item.style.webkitLineClamp = webkitLineClamp;
      item.style.overflow = overflow;
      item.style.display = display;
      item.style.height = height;

      item.classList.toggle('is-expandable', fullHeight > clampedHeight + 1);
    });
  },

  observeProducts() {
    this.observer = new MutationObserver(() => {
      requestAnimationFrame(() => {
        this.refreshTitles();
        this.checkExpandableTitles();
      });
    });

    document
      .querySelectorAll('.products-list, .product-box')
      .forEach((element) => {
        this.observer?.observe(element, {
          attributes: true,
          attributeFilter: ['class', 'style'],
          childList: true,
          subtree: true,
        });
      });
  },
};

export default thumbHeight;
